const fullYear = new Date().getFullYear();
export const zh_CN = {
  lang: 'zh_CN',
  layout: {
    home: '主页',
    header: {
      profile: '个人中心',
      download: '下载中心',
      password: '修改密码',
      logout: '退出登录'
    },
    footer: {
      website: '官网',
      document: '文档',
      authorization: '授权',
      ipc: '蜀ICP备17025563号-7',
      copyright: `© 2017-${fullYear} 成都论之道科技有限责任公司`
    },
    logout: {
      title: '系统提示',
      message: '确定要退出登录吗?'
    },
    tabs: {
      reload: '刷新当前页签',
      close: '关闭当前页签',
      closeLeft: '关闭左侧页签',
      closeRight: '关闭右侧页签',
      closeOther: '关闭其它页签',
      closeAll: '关闭全部页签',
      fullscreen: '内容区域全屏',
      fullscreenExit: '退出内容全屏'
    },
    setting: {
      title: '主题风格设置',
      sideStyles: {
        dark: '暗色侧栏',
        light: '亮色侧栏'
      },
      headStyles: {
        light: '亮色顶栏',
        dark: '暗色顶栏',
        primary: '主色顶栏'
      },
      layoutStyles: {
        side: '左侧菜单布局',
        top: '顶部菜单布局',
        mix: '混合菜单布局'
      },
      colors: {
        default: '拂晓蓝',
        dust: '薄暮',
        sunset: '日暮',
        volcano: '火山',
        purple: '酱紫',
        green: '极光绿',
        geekblue: '极客蓝'
      },
      darkMode: '开启暗黑模式',
      roundedTheme: '开启圆角主题',
      layout: '导航模式',
      sidebarLayout: '侧栏双排菜单',
      fluid: '内容区域铺满',
      other: '其它配置',
      more: '更多配置',
      tab: '页签配置',
      fixedHeader: '固定顶栏区域',
      fixedSidebar: '固定侧栏区域',
      fixedBody: '内容区域滚动',
      logoInHeader: 'Logo置于顶栏',
      colorfulIcon: '侧栏彩色图标',
      uniqueOpened: '侧栏排它展开',
      responsive: '移动端响应式',
      weakMode: '开启色弱模式',
      showTabs: '开启多页签栏',
      fixedHome: '固定主页页签',
      tabInHeader: '页签置于顶栏',
      tabStyle: '页签显示风格',
      tabStyles: {
        default: '默认',
        dot: '圆点',
        tag: '标签',
        card: '卡片'
      },
      menuItemTrigger: '混合菜单分割',
      transitionName: '路由切换动画',
      transitions: {
        slideRight: '滑动消退',
        slideBottom: '底部消退',
        zoomIn: '放大渐变',
        zoomOut: '缩小渐变',
        fade: '淡入淡出'
      },
      reset: '重置'
    }
  },
  login: {
    title: '用户登录',
    username: '请输入登录账号',
    password: '请输入登录密码',
    code: '请输入验证码',
    remember: '记住账号',
    login: '登录',
    passwordType: '密码登录',
    qrcodeType: '扫码登录',
    refreshQrcode: '刷新二维码'
  },
  list: {
    // 基础列表
    basic: {
      table: {
        avatar: '头像',
        username: '用户账号',
        nickname: '用户名',
        organizationName: '组织机构',
        phone: '手机号',
        email: '邮箱',
        roles: '角色',
        sexName: '性别',
        createTime: '创建时间',
        status: '状态',
        action: '操作'
      }
    }
  },
  /** 全局国际化配置 */
  global: {
    /** 按钮 */
    btns: {
      add: '添加',
      export: '导出',
      import: '导入',
      edit: '编辑',
      remove: '删除',
      search: '查询',
      reset: '重置',
      submit: '提交',
      submitImport: '提交导入',
      submitContinue: '提交并继续',
      confirm: '确认',
      revoke: '撤回',
      cancel: '取消',
      close: '关闭',
      upload: '上传',
      download: '下载',
      homePage: '首页',
      signIn: '登录',
      signOut: '退出',
      enabled: '启用',
      disabled: '禁用',
      locked: '锁定',
      resetPassword: '重置密码',
      notification: '通知',
      batchResetPassword: '批量重置密码',
      copy: '复制',
      assignPermissions: '分配权限',
      configuration: '配置',
      collapseAll: '折叠全部',
      expandAll: '展开全部',
      view: '查看',
      setAsPublished: '设置已发布',
      setAsUnpublished: '设置未发布',
      assignAdvisor: '分配导师',
      confirmSelection: '确认选择',
      unpairAdvisorStudent: '解除师生配对',
      batchAdd: '批量新增'
    },
    /** 导出 */
    export: {
      select: {
        range: '选择导出范围',
        fields: '选择导出字段'
      }
    },
    /** 占位符 */
    placeholder: {
      select: '请选择',
      input: '请输入',
      selectRange: '请选择范围',
      university: '所属大学',
      college: '所属学院',
      department: '所属系所',
      major: '所属专业',
      teaching: '所属教研室',
      grade: '所属年级',
      class: '所属班级',
      graduation: '毕业届次',
      studentType: '学生类别',
      degreeType: '学位类别',
      thesisType: '论文类型',
      thesisTitle: '论文题目',
      studentPhone: '学生电话',
      studentEmail: '学生邮箱',
      studentName: '学生姓名',
      studentId: '学生学号',
      supervisorName: '导师姓名',
      supervisorId: '导师账号'
    },
    tips: {
      processing: '处理中...',
      lodding: '加载中...',
      err404: '抱歉, 你访问的页面不存在.',
      tokenExpired: '登录会话已过期，请重新登录.',
      required: '不能为空，请输入',
      remove: '删除后数据不可恢复，是否执行?'
    },
    /** 任务状态 */
    task: {
      status: {
        pending: '待处理',
        processing: '处理中',
        completed: '已完成'
      }
    }
  }
};

export type Locale = typeof zh_CN;
